module.exports = __webpack_public_path__ + "img/csr_121222_C.ff618696.jpg";